export enum EventRole {
  SALE = "SALE",
  LSALE = "LSALE",
  TECH = "TECH",
  LTECH = "LTECH",
}
